/**
 * Cliente API del dashboard del super_admin (Sprint 13 S13-26).
 *
 * Una sola llamada a GET /dashboard/sa devuelve metricas agregadas
 * de todas las entidades del barrio.
 */
import { apiFetch } from './client';

export interface DashboardSa {
  casas: {
    total: number;
    activas: number;
  };
  personas: {
    total: number;
    activas: number;
    con_usuario_operativo: number;
  };
  usuarios: {
    operativos_activos: number;
    super_admin: number;
  };
  tenencias: {
    total: number;
    activas: number;
  };
  roles_vigentes: {
    vecino: number;
    comision: number;
    tesorero: number;
  };
  recursos: {
    total: number;
    entregados: number;
    por_tipo: {
      llavero: number;
      control_remoto: number;
      citofonia: number;
      acceso_app_wifi: number;
      otro: number;
    };
  };
  cuotas: {
    pendientes: number;
    en_abono: number;
    pagadas: number;
    vencidas: number;
    condonadas: number;
  };
  categorias: {
    activas: number;
    inactivas: number;
  };
  proyectos: {
    propuesto: number;
    aprobado: number;
    en_ejecucion: number;
    cerrado: number;
    cancelado: number;
  };
  configuracion_cuota: {
    vigente: boolean;
    monto_semestral: number | null;
    monto_mensual_equivalente: number | null;
    vigente_desde: string | null;
  };
}

export function getDashboardSa(): Promise<DashboardSa> {
  return apiFetch<DashboardSa>('/dashboard/sa');
}
